// extracted by mini-css-extract-plugin
export var dividerLine = "_5g-0";
export var errorBackground = "_5g-1";